<template>
    <div class="grid grid-cols-1 m-20 content-center justify-center">
        <h1 class="font-semibold text-sky-600 lg:text-9xl text-4xl text-center">Error 404</h1>
        <h5 class="font-light text-sky-500 text-center">Página no encontrada</h5>
        <a class="font-light text-sky-400 hover:text-sky-600 text-center underline" href="/">Volver al inicio</a>
    </div>
</template>
    
<script>

export default {
    name: '404View',
    metaInfo(){
        return{
        title: '404',
        description:'¡Error 404!, Oops! parece que la página que buscas no está disponible en la web de Eiji',
        }
    }
}
</script>